<template>
  <div style="width: 100%;background:rgba(245,245,245,1);
opacity:0.9;">
  <div class="content1">
   <div class="content-header1">
     友情链接：嘀哩嘀哩｜若初文学网｜二次元现场｜漫域网｜萌娘资源站｜网易漫画｜
     卡密动漫｜爱漫展｜大角虫漫画｜呲哩呲哩｜萌站｜C3动漫网｜网易二次元社区GACHA
   </div>
    <div v-if='ff == "1"'>
      <img src="../img/002.png" alt class="content-bady-wechat1" />
     <div class="content-bady-describe1">羁绊网官方微信</div>
   </div>
   <div class="content-fotter1">
     <img src="../img/logo.png" class="content-fotter-img1" />
     <div class="conten-fotter-describe1">
       <div>关于我们｜加入我们｜商务合作</div>
       <div>Copyringt 有妖气http://www.u17.com 北京四月星空网络技术有限公司 版权所有</div>
       <div>福建天下无双投资集团有限公司 闽ICP备16029788号-闽ICP备16029788号</div>
       <div>
         <img src="../../build/logo.png" style="height:18px;widht:16px" />
         <span>闽公网安备350121456479898号</span>
       </div>
     </div>
   </div>
 </div>
 </div>
</template>

<script>
  export default {
    name: 'App',
    props: ['ff'],
    components: {
    },


  }
</script>

<style>

  .content1 {
    width: 1200px;
    min-height:218px;

    display: flex;
    flex-direction: column;
    padding: 30px 0;
    align-items: center;margin: 0 auto;
    box-sizing: border-box;
  }
  .content-header1 {
    color: #808080;
    font-size: 12px;
  }
  .content-bady-wechat1 {
    height: 90px;
    width: 90px;
    margin: 35px 0 10px;
  }
  .content-bady-describe1 {
    color: #808080;
    font-size: 12px;
  }
  .content-fotter1 {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
  }
  .content-fotter-img1 {
    height: 70px;
    width: 190px;
  }
  .conten-fotter-describe1 {
    color: #808080;
    font-size: 12px;
    margin-left: 60px;
  }
  .conten-fotter-describe1 > div {
    line-height: 22px;
    height: 22px;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginfotter.vue